import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";

import confirmDelete from '../../components/ConfirmDelete';
import getEncodedImageUrl from "../../helpers/getEncodedImageUrl";
import ImgToolTip from '../ImgTooltip';

const SpeakerRow = ({ title, name, email, id, image, intl, deleteFn }) => {
  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container">
            {image ? (
              <img className="event-icon rounded-circle" src={getEncodedImageUrl(image, 85, 85)} alt="" />
            ) : (
              <img
                className="event-icon rounded-circle"
                src={`https://ui-avatars.com/api/?name=${name}&size=85&color=ff7142`}
                alt=""
              />
            )}
          </div>
          <div className="m-l-45">
            <h6>
              {title} {name}
            </h6>
            <span>{email}</span>
          </div>
        </div>
        <div className="del-event-container justify-content-center">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, (_id) => {
                deleteFn(_id)
              }, intl.formatMessage({id: 'action.delete-speaker'}));
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-speaker`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-speaker`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-speaker`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
        </div>
      </div>
      <Link className="d-flex w-10" to={`/speakers/edit/${id}`}>
        <Button className="btn-return">{intl.formatMessage({id: 'edit-new'})}</Button>
      </Link>
    </div>
  );
};

export default injectIntl(SpeakerRow);
